// src/services/providers.ts
// Thin service layer around Firestore helpers to enable future backend swaps.

import {
  getProviderByUid as _getProviderByUid,
  updateProvider as _updateProvider,
  createProviderSkeleton as _createProviderSkeleton,
  submitVerification as _submitVerification,
  adminApproveProvider as _adminApproveProvider,
  adminRejectProvider as _adminRejectProvider,
  adminSuspendProvider as _adminSuspendProvider,
  deleteProvider as _deleteProvider,
} from '@/lib/firestoreHelpers';
import type { Provider } from '@/types';

export const getProviderByUid = (uid: string) => _getProviderByUid(uid);
export const updateProvider = (uid: string, patch: Partial<Provider> | Record<string, any>) =>
  _updateProvider(uid, patch);
export const createProviderSkeleton = (uid: string, partial: Partial<Provider>) =>
  _createProviderSkeleton(uid, partial);
export const submitVerification = (
  uid: string,
  payload: {
    nationalIdFront: string;
    nationalIdBack: string;
    nonCriminalCertificate: string;
    certifications?: string[];
  },
) => _submitVerification(uid, payload);
export const adminApproveProvider = (uid: string) => _adminApproveProvider(uid);
export const adminRejectProvider = (uid: string, reason: string) =>
  _adminRejectProvider(uid, reason);
export const adminSuspendProvider = (uid: string) => _adminSuspendProvider(uid);
export const deleteProvider = (uid: string) => _deleteProvider(uid);
